/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { WebAppUpdateTranscriptionWordsFragmentDetailMutationRequest, WebAppUpdateTranscriptionWordsFragmentDetailMutationResponse, WebAppUpdateTranscriptionWordsFragmentDetailPathParams, WebAppUpdateTranscriptionWordsFragmentDetail404 } from "../models/WebAppUpdateTranscriptionWordsFragmentDetail";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { webAppUpdateTranscriptionWordsFragmentDetail } from "../axios/webAppUpdateTranscriptionWordsFragmentDetail";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const webAppUpdateTranscriptionWordsFragmentDetailMutationKey = () => [{ url: '/web-app/v1/fragments/:id/transcription/words' }] as const

export type WebAppUpdateTranscriptionWordsFragmentDetailMutationKey = ReturnType<typeof webAppUpdateTranscriptionWordsFragmentDetailMutationKey>

export function webAppUpdateTranscriptionWordsFragmentDetailMutationOptions<TContext = unknown>(config: Partial<RequestConfig<WebAppUpdateTranscriptionWordsFragmentDetailMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = webAppUpdateTranscriptionWordsFragmentDetailMutationKey()
        return mutationOptions<WebAppUpdateTranscriptionWordsFragmentDetailMutationResponse, ResponseErrorConfig<WebAppUpdateTranscriptionWordsFragmentDetail404>, {id: WebAppUpdateTranscriptionWordsFragmentDetailPathParams["id"], data: WebAppUpdateTranscriptionWordsFragmentDetailMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ id, data }) => {
            return webAppUpdateTranscriptionWordsFragmentDetail(id, data, config)
          },
        })

}

/**
 * @summary Replace fragment transcription words
 * {@link /web-app/v1/fragments/:id/transcription/words}
 */
export function useWebAppUpdateTranscriptionWordsFragmentDetail<TContext>(options: 
{
  mutation?: UseMutationOptions<WebAppUpdateTranscriptionWordsFragmentDetailMutationResponse, ResponseErrorConfig<WebAppUpdateTranscriptionWordsFragmentDetail404>, {id: WebAppUpdateTranscriptionWordsFragmentDetailPathParams["id"], data: WebAppUpdateTranscriptionWordsFragmentDetailMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<WebAppUpdateTranscriptionWordsFragmentDetailMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? webAppUpdateTranscriptionWordsFragmentDetailMutationKey()

          const baseOptions = webAppUpdateTranscriptionWordsFragmentDetailMutationOptions(config) as UseMutationOptions<WebAppUpdateTranscriptionWordsFragmentDetailMutationResponse, ResponseErrorConfig<WebAppUpdateTranscriptionWordsFragmentDetail404>, {id: WebAppUpdateTranscriptionWordsFragmentDetailPathParams["id"], data: WebAppUpdateTranscriptionWordsFragmentDetailMutationRequest}, TContext>
          

          return useMutation<WebAppUpdateTranscriptionWordsFragmentDetailMutationResponse, ResponseErrorConfig<WebAppUpdateTranscriptionWordsFragmentDetail404>, {id: WebAppUpdateTranscriptionWordsFragmentDetailPathParams["id"], data: WebAppUpdateTranscriptionWordsFragmentDetailMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<WebAppUpdateTranscriptionWordsFragmentDetailMutationResponse, ResponseErrorConfig<WebAppUpdateTranscriptionWordsFragmentDetail404>, {id: WebAppUpdateTranscriptionWordsFragmentDetailPathParams["id"], data: WebAppUpdateTranscriptionWordsFragmentDetailMutationRequest}, TContext>
      
}